import React, { useEffect } from 'react'
import { getToken, setToken } from '../../utils';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../redux/slices/userSlice';
import useApi from '../../hooks/useApi';
import { ACCESS_TOKEN } from '../../constants';

const CheckSubscriptionWrapper = ({children}) => {
    const token = JSON.parse(localStorage.getItem(ACCESS_TOKEN));
    console.log("token", token);
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const { Axios } = useApi();
    const fetchProfile = async () => {
        try {
            const result = await Axios.get(`api/user/profile`);
            setToken({
                ...token,
                user: {
                    ...token.user,
                    subscription: result.data.payload.user.subscription
                }
        });
            dispatch(login({
                ...user,
                subscription: result.data.payload.user.subscription
            }));
        }
        catch(e) {
            console.log(e);
        }
    };
    useEffect(() => {
        user.subscription?.remaining_days <= 3 &&
        fetchProfile();
    }, []);
return (
    <div key={children}>
    {children}
    </div>
)
}

export default CheckSubscriptionWrapper